import { cn } from "@/lib/utils"

/**
 * Placeholder block for data that is still loading. Hairline grey, 4px radius
 * (text bars). Media blocks pass their own radius. The pulse only runs when the
 * user allows motion. Keep the geometry of the loaded layout: bar height equals
 * the font size it stands in for.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn("motion-safe:animate-pulse rounded-[4px] bg-border", className)}
      {...props}
    />
  )
}

export { Skeleton }
